import React, { useState, useEffect, useRef } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  Box,
  Alert,
  AlertTitle,
  TextField,
  Button,
  IconButton,
  Autocomplete,
  Collapse,
  Paper,
  Typography
} from "@mui/material";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import transactionAPI from "../../Network/Transaction";
import Title from "./Title";
import { selectRoles } from "../../reduxStore/RolesReducer";

import moment from "moment";
import { selectTransactionFilter } from "../../reduxStore/SettingsReducer";

import LocationOnIcon from '@mui/icons-material/LocationOn';

import { SiMicrosoftexcel } from 'react-icons/si'
import { BsFilePdfFill } from 'react-icons/bs'
import geofenceAPI from "../../Network/Geofence";
import unitAPI from '../../Network/Unit'
import userAPI from "../../Network/User";
import CustomeSelectField from "../../Components/CustomeSelectField";
import helpers from "../../assets/js/helper";
import CustomDateTimeField from "../../Components/CustomDateTimeField";
import CustomDateField from "../../Components/CustomDateField";
import CustomDateRange from "../../Components/CustomDateRange";
import Stops from "./Stops/Stops";
import { FormControlLabel, Radio, RadioGroup, Checkbox } from "@mui/material";

const cookies = new Cookies();

const todayStart = new Date();
const yesterday = new Date(todayStart);
yesterday.setDate(yesterday.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

const todayEnd = new Date();
todayEnd.setHours(23, 59, 59, 999);

const CustomFilterBox = ({
  maintheme,
  filtersExpanded,
  setFiltersExpanded,
  t,
  handleSearchTermSourceGeofenceChange,
  searchTermSourceGeofence,
  loadingSourceGeofences,
  filters,
  sourceGeofences,
  setFilters,
  handleSearchTermDestinationGeofenceChange,
  searchTermDestinationGeofence,
  loadingDestinationGeofences,
  destinationGeofences,
  loadingAccounts,
  accounts,
  loading,
  loadData,
  handleSearchTermUnitChange,
  searchTermUnit,
  loadingUnits,
  units
}) => {
  return <Paper
    elevation={2}
    sx={{
      width: '100%',
      marginTop: '10px',
      marginBottom: '10px',
      borderRadius: '8px',
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box
      onClick={() => setFiltersExpanded(!filtersExpanded)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        backgroundColor: maintheme?.secondary || '#1976d2',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: maintheme?.secondary ? `${maintheme.secondary}dd` : '#1565c0',
        }
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Cairo-Bold',
          fontSize: '16px',
          color: '#fff'
        }}
      >
        {t('GLOBAL.filters') || 'الفلاتر'}
      </Typography>
      <IconButton
        size="small"
        sx={{
          color: '#fff',
          transform: filtersExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s'
        }}
      >
        <span style={{ fontSize: '20px' }}>▼</span>
      </IconButton>
    </Box>

    {/* Collapsible Content */}
    <Collapse in={filtersExpanded} timeout={{ enter: 600, exit: 400 }}>
      <Box sx={{ padding: '16px', backgroundColor: '#f3f3f3' }}>
        {/* First Row: Source, Destination, Accounts */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            marginBottom: '16px',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ flex: 1 }}>
            <CustomeSelectField
              label={t("TRANSACTIONS.source_geofence")}
              haswidth={true}
              onInputChange={handleSearchTermSourceGeofenceChange}
              inputValue={searchTermSourceGeofence}
              loading={loadingSourceGeofences}
              loadingText={t('GLOBAL.searching')}
              value={filters?.sourceGeofence}
              list={sourceGeofences}
              error={false}
              message={""}
              readOnly={false}
              onChange={(e, v) => {
                setFilters({
                  ...filters,
                  sourceGeofence: v,
                  source_geofence_id: v ? v?.id : ""
                })
              }}
              onClearClick={() => {
                setFilters({
                  ...filters,
                  sourceGeofence: null,
                  source_geofence_id: ""
                })
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <CustomeSelectField
              label={t("TRANSACTIONS.destination_geofence")}
              haswidth={true}
              onInputChange={handleSearchTermDestinationGeofenceChange}
              inputValue={searchTermDestinationGeofence}
              loading={loadingDestinationGeofences}
              loadingText={t('GLOBAL.searching')}
              value={filters?.destinationGeofence}
              list={destinationGeofences}
              error={false}
              message={""}
              readOnly={false}
              onChange={(e, v) => {
                setFilters({
                  ...filters,
                  destinationGeofence: v,
                  destination_geofence_id: v ? v?.id : ""
                })
              }}
              onClearClick={() => {
                setFilters({
                  ...filters,
                  destinationGeofence: null,
                  destination_geofence_id: ""
                })
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <CustomeSelectField
              label={t("UNITS.account_name")}
              haswidth={true}
              multiple={true}
              loading={loadingAccounts}
              loadingText={t('GLOBAL.searching')}
              value={filters?.accounts_selected}
              list={accounts}
              error={false}
              message={""}
              readOnly={false}
              onChange={(e, v) => {
                setFilters({
                  ...filters,
                  account_ids: v?.length > 0 ? v?.map(user => user?.id) : [],
                  accounts_selected: v
                })
              }}
              onClearClick={() => {
                setFilters({
                  ...filters,
                  account_ids: [],
                  accounts_selected: []
                })
              }}
            />
          </Box>

        </Box>

        {/* Second Row: Date Range, Is Monitored Filter and Search Button */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            marginBottom: '16px',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ flex: 1 }}>
            <CustomDateRange
              horizontal={true}
              dateRange={filters}
              setDateRange={(value) => {
                setFilters({
                  ...filters,
                  ...value
                })
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>

            <CustomeSelectField
              label={t("TRANSACTIONS.unit")}
              haswidth={true}
              onInputChange={handleSearchTermUnitChange}
              inputValue={searchTermUnit}
              loading={loadingUnits}
              loadingText={t('GLOBAL.searching')}
              value={filters?.unit}
              list={units}
              error={false}
              message={""}
              readOnly={false}
              onChange={(e, v) => {
                setFilters({
                  ...filters,
                  unit: v,
                  unit_id: v ? v?.id : ""
                })
              }}
              onClearClick={() => {
                setFilters({
                  ...filters,
                  unit: null,
                  unit_id: ""
                })
              }}
            />

          </Box>
          {/* Is Monitored Filter */}
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                padding: 1.5,
                margin: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                minWidth: "fit-content",
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Cairo-Bold',
                  fontSize: '14px',
                  color: '#333',
                  marginBottom: 0.5
                }}
              >
                {t('TRANSACTIONS.is_monitored')}
              </Typography>
              <RadioGroup
                row
                value={filters?.is_monitored}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    is_monitored: parseInt(e?.target.value)
                  })
                }}
                sx={{
                  "& .MuiTypography-root": {
                    fontFamily: "Cairo",
                    fontSize: "13px"
                  },
                }}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label={t("TRANSACTIONS.monitored")}
                />
                <FormControlLabel
                  value={0}
                  control={<Radio size="small" />}
                  label={t("TRANSACTIONS.not_monitored")}
                />
                <FormControlLabel
                  value={-1}
                  control={<Radio size="small" />}
                  label={t("UNITS.all")}
                />
              </RadioGroup>
            </Box>
          </Box>

          {/* Audit Status Filter */}
          <Box sx={{ flex: 1.5 }}>
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                padding: 1.5,
                margin: 1,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                minWidth: "fit-content",
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Cairo-Bold',
                  fontSize: '14px',
                  color: '#333',
                  marginBottom: 0.5
                }}
              >
                {t('TRANSACTIONS.reportByAuditedPerUser') || 'التدقيق'}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {[1, 2, 3, 4].map((id) => (
                  <FormControlLabel
                    key={id}
                    control={
                      <Checkbox
                        size="small"
                        checked={filters?.transaction_status_ids?.includes(id)}
                        onChange={() => {
                          const currentIds = filters?.transaction_status_ids || [];
                          const newIds = currentIds.includes(id)
                            ? currentIds.filter(item => item !== id)
                            : [...currentIds, id];
                          setFilters({
                            ...filters,
                            transaction_status_ids: newIds
                          });
                        }}
                      />
                    }
                    label={t(`TRANSACTIONS.status_${id}_name_total`)}
                    sx={{
                      "& .MuiTypography-root": {
                        fontFamily: "Cairo",
                        fontSize: "12px"
                      },
                      marginRight: 1,
                      marginLeft: 0
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>

        <Button
          disabled={loading}
          variant="contained"
          sx={{
            margin: 1,
            minWidth: "120px",
            backgroundColor: maintheme?.secondary,
            "&:hover": {
              backgroundColor: maintheme?.secondary ? `${maintheme.secondary}dd` : '#1565c0',
            },
            height: "40px",
            fontFamily: "Cairo-Bold",
          }}
          className="iconeFilterSearch"
          onClick={() => {
            loadData({ generateReport: true })
          }}
        >
          {t("GLOBAL.SEARCH_SEARCH_BUTTON")}
        </Button>
      </Box>
    </Collapse>
  </Paper>
}

export default function ReportStopsInfo() {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const transactionFilters = useSelector(selectTransactionFilter)
  const [branches, setBranches] = useState([])
  const [loadingBranches, setLoadingBranches] = useState(true)

  const timerSourceGeofences = useRef(null)
  const timerDestinationGeofences = useRef(null)

  const [sourceGeofences, setSourceGeofences] = useState([])
  const [destinationGeofences, setDestinationGeofences] = useState([])

  const [loadingSourceGeofences, setLoadingSourceGeofences] = useState(false)
  const [loadingDestinationGeofences, setLoadingDestinationGeofences] = useState(false)

  const [searchTermSourceGeofence, setSearchTermSourceGeofence] = useState("");
  const [searchTermDestinationGeofence, setSearchTermDestinationGeofence] = useState("");

  const [transactionProductTypes, setTransactionProductTypes] = useState([])
  const [loadingTransactionProductTypes, setLoadingTransactionProductTypes] = useState(true)

  const [accounts, setAccounts] = useState([])
  const [loadingAccounts, setLoadingAccounts] = useState(true)

  const [pageCount, setPageCount] = useState(0);
  const [openFilterColumn, setOpenFilterColumn] = useState(false);
  const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
  const [elementClicked, setElementClicked] = useState(null);
  const [showAlert, setShowAlert] = useState(false)
  const [loadingUnits, setLoadingUnits] = useState(false)
  const [units, setUnits] = useState([])
  const [searchTermUnit, setSearchTermUnit] = useState("")

  const timerUnits = useRef(null)

  const handleSearchTermUnitChange = async (newInputValue) => {
    setSearchTermUnit(newInputValue);

    if (timerUnits.current) {
      clearTimeout(timerUnits.current);
    }

    timerUnits.current = setTimeout(async () => {
      setLoadingUnits(true);
      try {
        const result = await unitAPI.getUnitList({
          params: {
            ...headerObject,
            name: newInputValue,
            page_size: 20,
            page: 1
          }
        });

        if (result.status && result?.data?.data?.data) {
          setUnits(result?.data?.data?.data);
        } else {
          setUnits([]);
        }
      } catch (error) {
        console.error("Error fetching units:", error);
        setUnits([]);
      } finally {
        setLoadingUnits(false);
      }
    }, 500);
  };

  const [filters, setFilters] = useState({
    unit: null,
    unit_id: "",
    sourceGeofence: null,
    source_geofence_id: "",
    destinationGeofence: null,
    destination_geofence_id: "",
    route: null,
    route_id: "",
    reportDate: moment(),
    report_date: moment().format('YYYY-MM-DD'),
    creationDateFrom: yesterday,
    creationDateTo: todayEnd,
    creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
    creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
    export_excel: false,
    export_pdf: false,
    note: "",
    destination_geofence_name: "",
    source_geofence_name: "",
    all_time: 0,
    account_ids: [],
    accounts_selected: [],
    is_monitored: 1,
    transaction_status_ids: []

  })
  const [reload, setReload] = useState(false)
  const [filtersExpanded, setFiltersExpanded] = useState(true)



  const [openForm, setOpenForm] = useState(false);
  const [openViewForm, setOpenViewForm] = useState(false);
  const [selectedObject, setselectedObject] = useState(null);
  const [showStops, setShowStops] = useState(false)
  const [showRoutes, setShowRoutes] = useState(false)

  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const controller = new AbortController();
  const [rowsTotal, setRowsTotal] = useState(0);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);

  const rolesRedux = useSelector(selectRoles)

  const [columns, setColumns] = useState([
    { field: "index_column", headerName: "ت", width: 50 },
    { field: "unit_name", headerName: t("TRANSACTIONS.unit_name"), minWidth: 200, flex: 2 },
    { field: "account_name", headerName: t("UNITS.account_name"), minWidth: 130, flex: 1 },
    { field: "total_transactions", headerName: t("TRANSACTIONS.total_transactions"), width: 80 },
    { field: "total_liters", headerName: t("TRANSACTIONS.total_liters"), width: 100 },
    { field: "source_geofence_name", headerName: t("TRANSACTIONS.source_geofence_name"), minWidth: 150, flex: 1.5 },
    { field: "destination_geofence_name", headerName: t("TRANSACTIONS.destination_geofence_name"), minWidth: 150, flex: 1.5 },
    { field: "inserted_at", headerName: t("TRANSACTIONS.inserted_at"), width: 140 },
    { field: "arrived_at", headerName: t("TRANSACTIONS.arrived_at"), width: 140 },
    { field: "liters", headerName: t("TRANSACTIONS.liters"), width: 100 },
    { field: "is_monitored_title", headerName: t("TRANSACTIONS.is_monitored"), width: 120 },
    { field: "transaction_status_name", headerName: t("TRANSACTIONS.transaction_status_name"), width: 120 },
    {
      field: "note",
      headerName: t("TRANSACTIONS.note"),
      minWidth: 250,
      flex: 3,
      renderCell: (params) => {
        const noteText = params.value || '';
        if (noteText.includes(':')) {
          const parts = noteText.split(':').map(part => part.trim()).filter(part => part);
          return (
            <Box sx={{ padding: '8px 0', direction: 'rtl', textAlign: 'left', width: '100%' }}>
              {parts.map((part, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: index < parts.length - 1 ? '4px' : '0', direction: 'ltr' }}>
                  <span style={{ marginRight: '4px', marginLeft: '8px' }}>•</span>
                  <span style={{ textAlign: 'right !important' }}>{part}</span>
                </Box>
              ))}
            </Box>
          );
        }

        return noteText
      }
    },
  ])

  const handleSearchTermSourceGeofenceChange = (newValue) => {

    setSearchTermSourceGeofence(newValue);
    if (timerSourceGeofences.current) {
      clearTimeout(timerSourceGeofences?.current)
    }
    timerSourceGeofences.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingSourceGeofences(true);

        const result = await geofenceAPI.getGeofenceList({
          params: {
            ...headerObject,
            name: newValue,
            port_type_ids: [1, 3],
            page_size: 20,
            page: 1
          }

        })
        setLoadingSourceGeofences(false);

        if (result.status && result?.data?.data?.data) {
          setSourceGeofences(result?.data?.data?.data)
        }
      }
      else {
        setSourceGeofences([])
      }
    }, 1000)
  };
  const handleSearchTermDestinationGeofenceChange = (newValue) => {

    setSearchTermDestinationGeofence(newValue);
    if (timerDestinationGeofences.current) {
      clearTimeout(timerDestinationGeofences?.current)
    }
    timerDestinationGeofences.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingDestinationGeofences(true);

        const result = await geofenceAPI.getGeofenceList({
          params: {
            ...headerObject,
            name: newValue,
            port_type_ids: [2, 3],
            page_size: 20,
            page: 1
          }

        })
        setLoadingDestinationGeofences(false);

        if (result.status && result?.data?.data?.data) {
          setDestinationGeofences(result?.data?.data?.data)
        }
      }
      else {
        setDestinationGeofences([])
      }
    }, 1000)
  };

  useEffect(() => {

    loadData()


  }, [pageNumber, pageSize, reload]);

  useEffect(() => {
    userAPI.getAccountList({
      params: {
        ...headerObject,
      }
    }).then(accountsResult => {
      if (accountsResult.status && accountsResult?.data?.data) {
        setAccounts(accountsResult?.data?.data)
      }
      setLoadingAccounts(false);
    }).catch(error => {
      console.log(error);
      setLoadingAccounts(false);
    }).finally(() => {
      setLoadingAccounts(false);
    })
  }, []);


  const headerObject = {
    username: cookies.get("user_name") ? cookies.get("user_name") : null,
    user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
    account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
    account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
    authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
    sid: cookies.get("sid") ? cookies.get("sid") : null,
    baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
    id: cookies.get("id") ? cookies.get("id") : null,
  }
  const loadData = async (searchParams) => {

    // if (!filters?.sourceGeofence?.name || !filters?.destinationGeofence?.name || !filters?.report_date) {
    //   setShowAlert(true)
    //   return
    // }
    // else {
    //   setShowAlert(false)
    // }

    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        ...headerObject,


      };
      let data = {
        ...(filters?.export_excel || filters?.export_pdf ? {} :
          {
            page: pageNumber,
            page_size: pageSize,
          }),

        search: "",
        ...searchParams,
        ...filters,

      };



      setLoading(true);

      const result = await transactionAPI.unitTransactionsDetailsReport({
        params: object,
        data: data,
        signal: controller?.signal,
      });
      setLoading(false);

      if (result.status && result?.data?.data) {


        if (filters?.export_excel) {
          setFilters({
            ...filters,
            export_excel: false
          })
          downloadExcel(result?.data?.data)
        }
        else if (filters?.export_pdf) {
          setFilters({
            ...filters,
            export_pdf: false
          })
          downloadPDF(result?.data?.data)
        }
        else {
          if (result?.data?.data?.data?.length > 0) {
            let hierarchicalData = []
            let globalIndex = 1

            // Create 3-level hierarchical structure: units -> routes -> transactions
            result?.data?.data?.data.forEach((unitData, unitIndex) => {
              // Level 1: Add master row (unit summary)
              const masterRow = {
                id: `unit-${unitData.unit_wialon_id || unitIndex}`,
                index_column: globalIndex++,
                unit_name: unitData.unit_name || 'مركبة غير معروفة',
                account_name: unitData.account_name || '',
                total_transactions: unitData.total_transactions,
                total_liters: unitData.total_liters,
                isMasterRow: true,
                isUnitRow: true,
                // Empty cells for master row
                source_geofence_name: '',
                destination_geofence_name: '',
                inserted_at: '',
                arrived_at: '',
                liters: '',
                is_monitored_title: '',
                note: ''
              }
              hierarchicalData.push(masterRow)

              // Level 2: Add route rows (source-destination pairs)
              if (unitData?.routes && unitData.routes.length > 0) {
                unitData.routes.forEach((route, routeIndex) => {
                  const routeRow = {
                    id: `route-${unitIndex}-${routeIndex}`,
                    index_column: '',
                    unit_name: '',
                    account_name: '',
                    total_transactions: '',
                    total_liters: '',
                    source_geofence_name: route.source_geofence_name || '',
                    destination_geofence_name: route.destination_geofence_name || route.destination_geofence_code || '',
                    inserted_at: '',
                    arrived_at: '',
                    liters: '',
                    is_monitored_title: '',
                    note: '',
                    isRouteRow: true,
                    isDetailRow: true
                  }
                  hierarchicalData.push(routeRow)

                  // Level 3: Add transaction detail rows
                  if (route?.transactions && route.transactions.length > 0) {
                    route.transactions.forEach((transaction, txIndex) => {
                      hierarchicalData.push({
                        id: `tx-${unitIndex}-${routeIndex}-${txIndex}`,
                        index_column: '',
                        unit_name: '',
                        account_name: '',
                        total_transactions: '',
                        total_liters: '',
                        source_geofence_name: '',
                        destination_geofence_name: '',
                        inserted_at: transaction.inserted_at || '',
                        arrived_at: transaction.arrived_at || '',
                        liters: transaction.liters || '',
                        is_monitored_title: transaction.is_monitored_title || '',
                        transaction_status_name: transaction.transaction_status_name || '',
                        note: transaction.note || '',
                        isTransactionRow: true,
                        isDetailRow: true
                      })
                    })
                  }
                })
              }
            })

            console.log('Hierarchical data:', hierarchicalData);
            setRows(hierarchicalData);
            setRowsTotal(result?.data?.data?.total_records);
            setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
          }
          else {
            setRows([]);
            setRowsTotal(0);
            setPageCount(0);
          }
        }
      } else {
        setFilters({
          ...filters,
          export_pdf: false,
          export_excel: false
        })

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }
      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };

  const createFunction = () => {
    setselectedObject(null);
    setOpenForm(true);
  };



  const downloadPDF = async (data, transaction) => {
    const result = await transactionAPI.downloadPdf({
      params: {
        ...headerObject,
        fileName: data?.result
      }
    })
    setLoading(false)
    if (result.status && result?.data) {
      const url = window.URL.createObjectURL(new Blob([result?.data]));
      const link = document.createElement('a');
      link.href = url;
      let reportName = t('TRANSACTIONS.reportBySourceAndProductType')
      if (filters?.sourceGeofence?.name) {
        reportName += (" : " + filters?.sourceGeofence?.name)
      }

      link.setAttribute('download', reportName + '.' + data?.type);
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    }

  }
  const exportFunction = () => {

    setFilters({
      ...filters,
      export_excel: true
    })
    setReload(!reload)
  }
  const exportPDF = () => {
    setFilters({
      ...filters,
      export_pdf: true
    })
    setReload(!reload)
  }

  const clearFilterFunction = () => {
    setFilters({
      name: "",
      code: "",
      transaction_id: "",
      transaction_number: "",
      type_id: null,
      wialon_id: null,
      export_excel: false,
      export_pdf: false,
      creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
      creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
      creationDateFrom: yesterday,
      creationDateTo: todayEnd,
      export_excel: false,
      note: "",
      destination_geofence_name: "",
      source_geofence_name: "",
      all_time: 1
    })
  }
  const searchFunction = () => {
    setReload(!reload)
    setPageNumber(1)
  };

  const downloadExcel = async (fileName) => {
    const result = await transactionAPI?.downloadExcel({
      params: {
        ...headerObject,
        fileName: fileName
      }
    })
    if (result.status && result?.data) {
      var _url = window.URL.createObjectURL(result?.data);
      window.open(_url, "_blank").focus(); // window.open + focus
    }
  }

  const getTitleAndSecondaryTitle = () => {
    let title = t('SIDEMENU.report_stops_info')



    let secondaryTitle = ""

    return {
      title: title,
      secondaryTitle: secondaryTitle
    }
  }


  const getRowClassName = (params) => {
    if (params?.row?.isUnitRow) {
      return 'master-row unit-row'
    }
    if (params?.row?.isRouteRow) {
      return 'route-row'
    }
    if (params?.row?.isTransactionRow) {
      return 'transaction-row'
    }
    return null
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "start",
        overflowX: "hidden",
        transition: "all ease-in-out 2s !important",
        "& .MuiChip-label": {
          fontFamily: "Cairo-Medium",
        },
        "& .unit-row": {
          backgroundColor: "#e3f2fd !important",
          fontWeight: "bold",
          "& .MuiDataGrid-cell": {
            fontFamily: "Cairo-Bold",
            fontSize: "15px",
            borderBottom: "2px solid #1976d2 !important",
            whiteSpace: "normal",
            lineHeight: "1.5 !important",
            padding: "8px !important"
          }
        },
        "& .route-row": {
          backgroundColor: "#fff3e0 !important",
          "& .MuiDataGrid-cell": {
            fontFamily: "Cairo-Bold",
            fontSize: "14px",
            paddingLeft: "32px !important",
            borderBottom: "1px solid #ff9800 !important",
            whiteSpace: "normal",
            lineHeight: "1.5 !important",
            padding: "8px !important"
          }
        },
        "& .transaction-row": {
          backgroundColor: "#fafafa !important",
          "& .MuiDataGrid-cell": {
            fontFamily: "Cairo",
            fontSize: "13px",
            paddingLeft: "64px !important",
            whiteSpace: "normal",
            lineHeight: "1.5 !important",
            padding: "8px !important"
          }
        },
        "& .unit-row:hover": {
          backgroundColor: "#bbdefb !important",
        },
        "& .route-row:hover": {
          backgroundColor: "#ffe0b2 !important",
        },
        "& .transaction-row:hover": {
          backgroundColor: "#f5f5f5 !important",
        }
      }}
    >

      {showStops ? (
        <Stops
          openForm={showStops}
          setOpenForm={setShowStops}
          data={selectedObject?.details}
        />
      ) : null}

      {showAlert ?
        <Alert sx={{
          fontFamily: 'Cairo',
          width: '100%'
        }} severity="warning">
          <AlertTitle sx={{
            fontFamily: 'Cairo'
          }}>تنبيه</AlertTitle>
          يجب اختيار  <strong>جميع الحقول</strong> للبحث عن البيانات
        </Alert>
        : null
      }


      <Grid
        dosntHaveSearch={true}
        rows={rows}
        multipleExports={rolesRedux?.export_transaction?.value ?
          [
            { icon: <SiMicrosoftexcel color="green" size={"25"} />, name: t('TRANSACTIONS.exportExcel'), key: 'report1', onClick: () => { exportFunction() } },
            { icon: <BsFilePdfFill color="red" size={"25"} />, name: t('TRANSACTIONS.exportPDF'), key: 'report4', onClick: () => { exportPDF() } },
          ] : []
        }
        fixHeight={'calc(100vh - 300px)'}
        getRowClassName={getRowClassName}
        hasExport={false}
        exportFunction={exportFunction}
        columns={columns}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        loading={loading}
        handlePageChange={handlePageChange}
        rowsTotal={rowsTotal}
        checkScreenSize={screenwidth}
        pageCount={pageCount}
        openFilterColumn={openFilterColumn}
        elementClicked={elementClicked}
        setElementClicked={setElementClicked}

        setOpenFilterColumn={setOpenFilterColumn}
        setColumnFilterValue={setOpenFilterColumnValue}
        columFilterValue={openFilterColumnValue}
        getRowHeight={() => 'auto'}
        clearFunction={clearFilterFunction}
        searchFunction={searchFunction}
        hasCreate={false}
        creatFunction={createFunction}
        hasColumnsHidShow={false}
        setColumns={setColumns}
        CustomFilterBox={
          <CustomFilterBox
            maintheme={maintheme}
            filtersExpanded={filtersExpanded}
            setFiltersExpanded={setFiltersExpanded}
            t={t}
            handleSearchTermSourceGeofenceChange={handleSearchTermSourceGeofenceChange}
            searchTermSourceGeofence={searchTermSourceGeofence}
            loadingSourceGeofences={loadingSourceGeofences}
            filters={filters}
            sourceGeofences={sourceGeofences}
            setFilters={setFilters}
            handleSearchTermUnitChange={handleSearchTermUnitChange}
            searchTermUnit={searchTermUnit}
            loadingUnits={loadingUnits}
            units={units}
            handleSearchTermDestinationGeofenceChange={handleSearchTermDestinationGeofenceChange}
            searchTermDestinationGeofence={searchTermDestinationGeofence}
            loadingDestinationGeofences={loadingDestinationGeofences}
            destinationGeofences={destinationGeofences}
            loadingAccounts={loadingAccounts}
            accounts={accounts}
            loading={loading}
            loadData={loadData}
          />
        }
        LeftHeaderComponent={
          <Title
            title={getTitleAndSecondaryTitle()?.title}
            secondaryTitle={getTitleAndSecondaryTitle()?.secondaryTitle}
          />
        }
        filterChilds={
          <Search
            filters={filters}
            setFilters={setFilters}
            loadingBranches={loadingBranches}
            branches={branches}
            transactionProductTypes={transactionProductTypes}
            loadingTransactionProductTypes={loadingTransactionProductTypes}
            showBySequence={
              {
                sourceGeofence: 1,
                destinationGeofence: 2,
                report_date: 3
              }
            }


          />
        }
      />

    </Box>
  );
}
